import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { mq } from '../../styles/vars/media-queries.style'

export const BookingBannerMain = styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${props => props.background};
`

export const BookingBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.light};
`

export const BookingBannerImageWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  border-radius: 0.6rem;

  :nth-child(1) {
    left: 0;
    top: 0;
    transform: translate(0%, 0%) scale(0.7);
    height: 10.5rem;
    width: 15.4rem;

    ${mq.tabletP} {
      left: auto;
      right: 55%;
      transform: translate(-100%, -10%);
    }
  }

  :nth-child(2) {
    top: 44%;
    right: 67%;
    transform: translate(-100%, -50%);
    height: 13.3rem;
    width: 19.5rem;
  }

  :nth-child(3) {
    top: 79%;
    right: 57%;
    transform: translate(-100%, -50%);
    height: 11.8rem;
    width: 17.3rem;
  }

  :nth-child(4) {
    top: 28%;
    left: 59%;
    transform: translate(100%, -50%);
    height: 11.2rem;
    width: 16.5rem;
  }

  :nth-child(5) {
    top: 60%;
    left: 71%;
    transform: translate(100%, -50%);
    height: 12.5rem;
    width: 18.3rem;
  }

  :nth-child(6) {
    bottom: 0;
    right: 0;
    transform: translate(0%, 0%) scale(0.7);
    height: 10.5rem;
    width: 15.4rem;

    ${mq.tabletP} {
      left: 55%;
      right: auto;
      transform: translate(100%, 10%);
    }
  }

  :nth-child(2),
  :nth-child(5) {
    display: none;

    ${mq.desk} {
      display: block;
    }
  }
`
